<template>
  <div>
    <div class="wrap-style" v-for="(form, idx) in formDataList" :key="(form.callDocNumber || '') + '-' + idx">
      <div>
        <span class="company">LINSY</span>
        <span class="company2">林氏</span>
      </div>
      <div class="title">叫料单通知单</div>
      <div class="info">
        <div class="item">
          <div class="label">加工厂</div>
          <div class="underline content">{{form.organizationName}}</div>
        </div>
        <div class="item">
          <span class="label">叫料单号</span>
          <div class="underline content">{{form.callDocNumber}}</div>
        </div>
      </div>
      <div class="info">
        <div class="item">
          <div class="label">配送地址</div>
          <div class="underline content">{{form.supplierAddress}}</div>
        </div>
        <div class="item">
          <div class="label">要求送达时间</div>
          <div class="underline content">{{form.demandDate}}</div>
        </div>
      </div>
      <table border="1" class="table-style" width="100%">
        <tr>
          <td class="tac table-title">序号</td>
          <td class="tac table-title">对应工单号</td>
          <td class="tac table-title">sku编码</td>
          <td class="tac table-title">物料名称</td>
          <td class="tac table-title">单位</td>
          <td class="tac table-title">叫料量</td>
          <td class="tac table-title">指定批次号</td>
          <td class="tac table-title">色号&色差</td>
          <td class="tac table-title">备注</td>
        </tr>
        <tr v-for="(item) in form.lineList" :key="(item.callDocNumber || form.callDocNumber) + '-' + item.lineNumber">
          <td class="tac" width="5%">{{ item.lineNumber }}</td>
          <td class="tac" width="12%">
            <div v-html="item.demandWipEntityName"></div>
          </td>
          <td class="tac" width="8%">{{ item.itemCode }}</td>
          <td class="tac" width="17%">{{ item.itemName }}</td>
          <td class="tac" width="5%">{{ item.uom }}</td>
          <td class="tac" width="10%">{{item.demandQty}}</td>
          <td class="tac" width="13%">{{ item.lotNumber }}</td>
          <td class="tac" width="12%">{{item.colorNumDiff}}</td>
          <td class="tac" width="18%">{{item.comment}}</td>
        </tr>
      </table>
      <div class="info creator">
        <div class="item">
          <div class="label">制单人</div>
          <div class="underline content">{{name}}</div>
        </div>
        <div class="item">
          <div class="label">制单时间</div>
          <div class="underline content">{{createTime}}</div>
        </div>
      </div>
      <div class="tip">本单一式两份，叫料方底单一份，另一方送达VMI库，指定批次号、色号及色差根据当前库存尾料，选择性填写，以便配组</div>
      <div class="info">
        <div class="file">文件编号：LINSY-YCLB-CYY-WK-005</div>
        <div class="file">文件版本号：20231110-V1.0</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PrintCallMaterial',
  data () {
    return {
      formDataList: [],
      createTime: ''
    }
  },
  computed: {
    ...mapState({
      name: (state) => state.user.name
      // avatar: (state) => state.user.avatar
    })
  },
  methods: {
    show(data) {
      this.createTime = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
      const list = Array.isArray(data) ? data : (data ? [data] : []);
      this.formDataList = list.map((one) => {
        const normalized = one ? { ...one } : { lineList: [] };
        if (!Array.isArray(normalized.lineList)) {
          normalized.lineList = [];
        }
        return normalized;
      });
    }
  }
}
</script>

<style lang="less" scoped>
.wrap-style{
  font-family: "黑体", "微软雅黑", "宋体", serif;
  color: #000;
  page-break-after: always;
  padding: 10px;
  table{
    // border: 1px solid #7030a0;
    td{
      // border-style: dotted;
    }
  }
  .title{
    text-align: center;
    font-weight: 700;
    font-size: 18px;
    padding-bottom: 10px;
  }
}
.table-title{
  font-weight: 700;
  font-size: 15px;
}
.table-style{
  width: 100%;
}
.tac{
  text-align: center;
}
tr{
  height: 30px;
}
td{
  padding: 0 5px;
}
.underline {
  border-bottom: 2px solid #000;
  padding-bottom: 2px;
}
.label{
  min-width: 60px;
  text-align: right;
  margin-right: 5px;
  font-weight: 700;
  font-size: 15px;
}
.info{
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  .item{
    display: flex;
  }
  .content{
    min-width: 140px;
  }
}
.creator{
  padding-top: 20px;
}
.tip{
  padding: 10px 50px 10px 50px;
  text-align: center;
  color: #000;
  font-style: italic;
}
.file{
  font-style: italic;
}
.company{
  font-size: 26px;
  font-weight: 700;
  color: #1ba49e;
  margin-right: 10px;
}
.company2{
  font-size: 25px;
  color: #1ba49e;
}
</style>
